import fetch from '@rd-web-markets/shared/dist/services/Fetcher';
import { request } from '@rd-web-markets/shared/dist/services/request';
const financialDetailsDocumentsService = {
  delete(financialDetailId, id) {
    return fetch(`/api/financial_details/${financialDetailId}/documents/${id}`, {
      ...request.delete
    });
  }
};
export default financialDetailsDocumentsService;